import RfiRecipientListItem from './RfiRecipientListItem.component';

export default RfiRecipientListItem;
